import React, { Fragment, memo, useCallback, useState } from 'react';
import { useObservable } from 'react-use-observable';

import { Badge, Tabs } from 'antd';

import HelperPage from 'v2/components/Shared/HelperPage';
import TopPage from 'v2/components/Shared/TopPage';
import Tour from 'v2/components/Shared/Tour';
import refundService from 'v2/services/requestManagement/refund';

import Refund from './Refund';
import { steps } from './tour';

type IRequestManagementTabs = 'refund' | 'dispute' | 'partnership';

const RequestManagement = memo(() => {
  const [pagination] = useObservable(() => {
    return refundService.getPaginationResponse();
  }, []);

  const [tab, setTab] = useState<IRequestManagementTabs>('refund');

  const handleChange = useCallback((key: string) => {
    setTab(key as IRequestManagementTabs);
  }, []);

  const tabItems = [
    {
      key: 'refund',
      label: (
        <Badge count={pagination?.total_items || 0} showZero={false} offset={[6, -2]} color='red'>
          Reembolsos
        </Badge>
      )
    }
  ];

  return (
    <Fragment>
      {!!pagination?.total_items && <Tour name='pending_actions_tour' steps={steps} />}
      <div>
        <TopPage
          title='Ações pendentes'
          extra='Consulte todas as ações pendentes e gerencie suas solicitações'
          additionalContent={
            <HelperPage
              id='helper_request_management_button'
              title='Solicitações de Reembolso'
              name='request_management_refund'
            />
          }
          disableAlerts
        />

        <div>
          <Tabs className='mb-4' activeKey={tab} onChange={handleChange} items={tabItems} />
          {tab === 'refund' && <Refund />}
        </div>
      </div>
    </Fragment>
  );
});

export default RequestManagement;
